import React from "react";
import { View, Text, ScrollView, TouchableOpacity } from "react-native";
import ActionSheet, { ActionSheetRef } from "react-native-actions-sheet";
import { useRef, useState } from "react";

export const notificationSheetRef = React.createRef<ActionSheetRef>();

const NotificationsSheet = () => {
  // Sample notifications list (empty for now)
  const [notifications] = useState<string[]>([]); // Replace with real data if needed

  return (
    <ActionSheet ref={notificationSheetRef} containerStyle={{ height: '95%', padding: 20 }}>
      <Text className="text-lg font-semibold mb-4">Notifications</Text>

      {notifications.length === 0 ? (
        <View className="items-center justify-center py-10">
          <Text className="text-gray-500 text-sm">📭 No notifications found yet</Text>
        </View>
      ) : (
        <ScrollView className="max-h-80">
          {notifications.map((note, index) => (
            <TouchableOpacity key={index} className="mb-4">
              <Text className="text-sm text-gray-800">🔔 {note}</Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      )}
    </ActionSheet>
  );
};

export default NotificationsSheet;
